const Constants = {
  ImpersonatePath: "/impersonate_iir6uQua"
};

export default Constants;
